import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useEffect,
} from 'react';
import dayjs from 'dayjs';
// import { useAuth } from './AuthContext';
// import { useQuery } from '@tanstack/react-query';
// import { axiosInstance } from '@/lib/axios';
import { useGetRegionWiseAccounts } from '@/lib/api/hooks/useAccounts';
import { useRegion } from './CountryContext';
interface Profile {
  linkedAccountId(linkedAccountId: any): unknown;
  isMarketingStreamActivate: unknown;
  is_marketing_stream_activate: unknown;
  accountId: string;
  id: number;
  profileId: string;
  accountName: string;
  selected: boolean;
}

interface AdAccount {
  id: number;
  name: string;
  profiles: Profile[];
  selected: boolean;
}
interface HeaderStateType2 {
  // Page title of the current view
  pageTitle: string;
  setPageTitle: Dispatch<SetStateAction<string>>;

  // Ad accounts with multi-selection state
  adAccounts: AdAccount[];
  setAdAccounts: Dispatch<SetStateAction<AdAccount[]>>;

  // Dropdown visibility for Ad Accounts
  adAccountVisible: boolean;
  setAdAccountVisible: Dispatch<SetStateAction<boolean>>;

  // Date range using native Date objects
  dateRange: [dayjs.Dayjs, dayjs.Dayjs];
  setDateRange: Dispatch<SetStateAction<[dayjs.Dayjs, dayjs.Dayjs]>>;

  // Date picker popover visibility
  datePickerVisible: boolean;
  setDatePickerVisible: Dispatch<SetStateAction<boolean>>;

  // advertierId
  advertiserId: string[];
  setAdvertiserId: Dispatch<SetStateAction<string[]>>;

  // Current user role (not full user info)
  role: string;
  setRole: Dispatch<SetStateAction<string>>;

  // profileid
  profileId: string;
  setProfileId: Dispatch<SetStateAction<string>>;

  // linkedAccountId
  linkedAccountId: number;
  setLinkedAccountId: Dispatch<SetStateAction<number>>;
}

// Create the context
const HeaderState2 = createContext<HeaderStateType2 | undefined>(undefined);

export const HeaderStateProvider2 = ({ children }: { children: ReactNode }) => {
  // 1. Page title
  const getPageTitle = () => {
    return 'Dashboard'; // Default title
  };
  const [pageTitle, setPageTitle] = useState(getPageTitle());

  const { selectedRegion } = useRegion();
  const { data: RegionWiseAccount, isFetched: RegionWiseAccountFetched } =
    useGetRegionWiseAccounts(selectedRegion.countrycode!);
  // const { user } = useAuth();

  // const { data: accountsData, isFetched } = useQuery({
  //   queryKey: ['accounts'],
  //   queryFn: async () => {
  //     const { data } = await axiosInstance.get('/accounts');
  //     return data;
  //   },
  //   enabled: !!user,
  // });

  // 2. Ad accounts with multi-selection
  const [adAccounts, setAdAccounts] = useState<AdAccount[]>([]);
  const [advertiserId, setAdvertiserId] = useState<string[]>([]);
  const [adAccountVisible, setAdAccountVisible] = useState(false);
  const [profileId, setProfileId] = useState<string>('');
  const [linkedAccountId, setLinkedAccountId] = useState<number>(0);
  // 3. Date range
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs]>([
    dayjs().subtract(7, 'day'),
    dayjs(),
  ]);
  const [datePickerVisible, setDatePickerVisible] = useState(false);

  // 4. User role
  const [role, setRole] = useState('Manager');

  useEffect(() => {
    if (RegionWiseAccountFetched && RegionWiseAccount) {
      const accountsWithSelection = RegionWiseAccount.map((account: any) => ({
        ...account,
        selected: false,
        profiles: account.profiles.map((profile: any) => ({
          ...profile,
          selected: false,
        })),
      }));

      // Set tempValue to reflect the applied selection

      setAdAccounts(accountsWithSelection);
    }
  }, [RegionWiseAccountFetched, RegionWiseAccount]);

  return (
    <HeaderState2.Provider
      value={{
        pageTitle,
        setPageTitle,
        adAccounts,
        setAdAccounts,
        advertiserId,
        setAdvertiserId,
        adAccountVisible,
        setAdAccountVisible,
        dateRange,
        setDateRange,
        datePickerVisible,
        setDatePickerVisible,
        role,
        setRole,
        profileId,
        setProfileId,
        linkedAccountId,
        setLinkedAccountId,
      }}
    >
      {children}
    </HeaderState2.Provider>
  );
};

// Custom hook for consuming header state

export const useHeaderStateProvider2 = () => {
  const context = useContext(HeaderState2);
  if (!context) {
    throw new Error(
      'useHeaderStateProvider2 must be used within HeaderStateProvider2'
    );
  }
  return context;
};
